<template>
  <div>
    <a-page-header
      class="page-header"
      :ghost="false"
      style="margin-bottom: 16px"
    >
      <template #title>
        <a-space size="middle">
          <a-icon type="alert"></a-icon>
          <span>告警规则</span>
        </a-space>
      </template>
      <span>日志告警规则包含名称、严重性、查询语句等配置。</span>
    </a-page-header>
    <a-card :bordered="false" style="margin-bottom: 16px">
      <list-layout
        :table-operation-width="170"
        :column-default-selected="columnDefaultSelected"
        :columns-all="columnsAll"
        :get-table-data-func="getFunc"
        :tools-list="['search', 'leftTool', 'reload', 'setting']"
        :refresh="refresh"
        :defaultSelected="tableSelectData"
        @tableSelectData="(v) => tableSelectData = v"
      >
        <template #leftTool>
          <create-button @click="$refs.inputDrawer.show()">
          </create-button>
        </template>
        <template #name="{ slotProps }">
          <a-tooltip placement="topLeft" :title="slotProps.text">
            {{ slotProps.text }}
          </a-tooltip>
        </template>
        <template #logType="{ slotProps }">
          {{ $t(`log_type.${slotProps.text}`) }}
        </template>
        <template #search="{ slotProps }">
          <a-tooltip placement="topLeft" :title="slotProps.text">
            {{ slotProps.text }}
          </a-tooltip>
        </template>
        <template #period="{ slotProps }">
          {{ slotProps.text }} 分
        </template>
        <template #aggregationMethod="{ slotProps }">
          {{ $t(`log_aggregation_method.${slotProps.text}`) }}
        </template>
        <template #condition="{ slotProps }">
          {{ $t(`compare_condition_mark.${slotProps.text}`) }}
        </template>
        <template #active="{ slotProps }">
          <a-switch :checked="slotProps.text"  @change="v => changeStatus(v, slotProps.record)" :loading="checkedDisabled"></a-switch>
        </template>
        <template #severity="{ slotProps }">
          <alert-severity-tag :severity="slotProps.text"></alert-severity-tag>
        </template>
        <template #operation="{ slotProps }">
          <edit-button
            @click="$refs.inputDrawer.show(slotProps.record.id)"
          ></edit-button>
          <delete-button @confirm="confirm(slotProps.record.id)"></delete-button>
        </template>
      </list-layout>
    </a-card>
    <input-drawer ref="inputDrawer" @ok="confirm"></input-drawer>
  </div>
</template>

<script>
import { getLogTriggerList, deleteLogTrigger, updateLogTrigger } from '@/api/log-trigger'
import ListLayout from '@/components/ListLayout.vue'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'
import CreateButton from '@/components/button/CreateButton'
import AlertSeverityTag from '@/components/tag/AlertSeverityTag.vue'
import InputDrawer from './modules/InputDrawer.vue'

export default {
  name: 'LogTrigger',
  components: {
    AlertSeverityTag,
    DeleteButton,
    EditButton,
    CreateButton,
    InputDrawer,
    ListLayout
  },
  data () {
    return {
      getFunc: getLogTriggerList,
      checkedDisabled: false,
      columnsAll: [
        {
          dataIndex: 'name',
          title: '名称',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'log_type',
          title: '日志类型',
          width: 120,
          scopedSlots: {
            customRender: 'logType'
          }
        },
        {
          dataIndex: 'severity',
          title: '严重性',
          width: 120,
          scopedSlots: {
            customRender: 'severity'
          }
        },
        {
          dataIndex: 'search',
          title: '查询语句',
          width: 300,
          ellipsis: true,
          scopedSlots: {
            customRender: 'search'
          }
        },
        {
          dataIndex: 'period',
          title: '统计周期',
          width: 100,
          scopedSlots: {
            customRender: 'period'
          }
        },
        {
          dataIndex: 'aggregation_method',
          title: '统计方式',
          width: 120,
          scopedSlots: {
            customRender: 'aggregationMethod'
          }
        },
        {
          dataIndex: 'aggregation_field',
          title: '统计字段',
          width: 120,
          scopedSlots: {
            customRender: 'aggregationField'
          }
        },
        {
          dataIndex: 'condition',
          title: '判断条件',
          width: 140,
          align: 'center',
          scopedSlots: {
            customRender: 'condition'
          }
        },
        {
          dataIndex: 'value',
          title: '值',
          width: 100
        },
        {
          dataIndex: 'active',
          title: '启用状态',
          width: 100,
          fixed: 'right',
          scopedSlots: {
            customRender: 'active'
          }
        }
      ],
      columnDefaultSelected: [
        'name',
        'log_type',
        'severity',
        'period',
        'aggregation_method',
        'condition',
        'value',
        'active'],
      tableSelectData: [],
      refresh: false
    }
  },
  methods: {
    async confirm (id = '') {
      if (id) {
        await deleteLogTrigger(id).then(res => {
          this.$message.success(res.message)
        })
        this.tableSelectData.splice(this.tableSelectData.findIndex(item => item.key === id), 1)
      }
      this.refresh = !this.refresh
    },
    changeStatus (active, item) {
      this.checkedDisabled = true
      updateLogTrigger(item.id, { active }).then(res => {
        this.$message.success(res.message)
        this.refresh = !this.refresh
      }).finally(() => {
        this.checkedDisabled = false
      })
    }
  }
}
</script>
